class popup {
	constructor(config) {
		this.config = Object.assign({
			scope: '#popup-msg'
		}, config);

		this.$scope = $(this.config.scope);
		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		this.openModal();
	}

	addEventListeners() {
		this.$scope.on('hide.bs.modal', this.hideModal.bind(this));
	}

	openModal() {
		let hide = sessionStorage.getItem("hide-popup");
		if(hide && hide === 'true') {
			return;
		}

		try {
			let delay = this.$scope.data('delay') ?? 0
			setTimeout(() => {
				let modal = bootstrap.Modal.getOrCreateInstance(this.$scope[0]);
				modal.show();
				sessionStorage.setItem("hide-popup", 'true');
			}, delay);
		} catch (error) {
		}
	}

	hideModal(event) {
		sessionStorage.setItem("hide-popup", 'true');
	}
}

export default new popup;
